module.exports = __webpack_public_path__ + "media/12_21.e7abefac.wav";